import React from "react";
import { MyContactRecentData } from "../common/Helper";
import { DateRangeIcon } from "../common/Icon";

const ContactRecents = () => {
  return (
    <>
      <div className="px-2.5 lg:h-[calc(100vh-200px)] 3xl:h-[calc(100vh-210px)] lg:overflow-y-auto overflow_x_scroll_style ">
        {MyContactRecentData.map((obj, index) => (
          <div
            key={index}
            className="w-full hover:shadow-workflow_item_card_shadow rounded-md px-5 py-2 mb-[15px]">
            <div className="flex items-center">
              <img src={obj.memberimg} alt="trading-scerets-img" />
              <div className="pl-5">
                <p className="font-normal text-black text-xs md:text-sm 3xl:text-base">
                  {obj.membertext}
                </p>
                <span className="flex items-center pt-1.5">
                  {obj.ContactStatusIcon}
                  <p className="text-xs 3xl:text-sm font-normal text-green pl-2.5">
                    {obj.ContactTeamLevelText}
                  </p>
                  <span className="flex items-center pl-[5px]">
                    <DateRangeIcon />
                    <p className="text-[10px] 3xl:text-xs font-normal text-gray pl-[1px]">
                      {obj.ContactFullDate}
                    </p>
                  </span>
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ContactRecents;
